export class MenuLinkModel {
    get hasChildren() {
        return this.children && this.children.length ? true : false;
    }
    ;
    constructor(name, group, text, icon, visible, children, licenseRule) {
        this.route = "";
        this.routeGroup = "";
        this.text = "";
        this.icon = "";
        this.visible = true;
        this.child = false;
        this.children = [];
        this.route = name;
        this.routeGroup = group;
        this.text = text;
        this.icon = icon;
        this.visible = visible != undefined ? visible : true;
        this.children = children || [];
        this.licenseRule = licenseRule;
    }
}
